import type { ComponentMeta } from "@mijalowcode/types";
import { ComponentCategory, PropType } from "@mijalowcode/types";

export const SpaceMeta: ComponentMeta = {
  componentName: "Space",
  package: "antd",
  title: "间距",
  description: "用于包裹并排列子组件的间距容器",
  category: ComponentCategory.LAYOUT,
  visibleInComponentPanel: true,
  icon: "SplitCellsOutlined",
  canHaveChildren: true,
  props: [
    {
      name: "direction",
      label: "方向",
      type: PropType.ENUM,
      defaultValue: "horizontal",
      options: [
        { label: "水平", value: "horizontal" },
        { label: "垂直", value: "vertical" },
      ],
      group: "基础",
    },
    {
      name: "size",
      label: "间距大小",
      type: PropType.ENUM,
      defaultValue: "middle",
      options: [
        { label: "小", value: "small" },
        { label: "中", value: "middle" },
        { label: "大", value: "large" },
      ],
      group: "基础",
    },
    {
      name: "align",
      label: "对齐方式",
      type: PropType.ENUM,
      defaultValue: "center",
      options: [
        { label: "起始", value: "start" },
        { label: "结束", value: "end" },
        { label: "居中", value: "center" },
        { label: "基线", value: "baseline" },
      ],
      group: "布局",
    },
    {
      name: "wrap",
      label: "自动换行",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "布局",
    },
    {
      name: "showPlaceholder",
      label: "显示拖拽提示",
      type: PropType.BOOLEAN,
      defaultValue: true,
      description: "仅在容器内无子组件时显示",
      group: "功能",
    },
    {
      name: "placeholderText",
      label: "提示文案",
      type: PropType.STRING,
      defaultValue: "拖拽组件到此处",
      group: "功能",
    },
    {
      name: "style",
      label: "样式",
      type: PropType.OBJECT,
      group: "样式",
    },
    {
      name: "className",
      label: "类名",
      type: PropType.STRING,
      group: "样式",
    },
    {
      name: "placeholderStyle",
      label: "提示样式",
      type: PropType.OBJECT,
      description: "用于覆盖空状态提示的默认样式",
      group: "样式",
    },
  ],
  defaultProps: {
    direction: "horizontal",
    size: "middle",
    showPlaceholder: true,
    placeholderText: "拖拽组件到此处",
  },
  defaultStyle: {
    width: "100%",
  },
  docLinks: [
    {
      title: "Space 文档",
      url: "https://5x-https://5x-ant-design.antgroup.com//components/space-cn",
      source: "antd",
    },
  ],
  npm: {
    package: "antd",
    exportName: "Space",
  },
  snippet: {
    componentName: "Space",
    package: "antd",
    props: { direction: "horizontal", size: "middle" },
    children: [
      {
        componentName: "Button",
        package: "antd",
        props: {
          type: "primary",
          children: "按钮1",
        },
      },
      {
        componentName: "Button",
        package: "antd",
        props: {
          children: "按钮2",
        },
      },
    ],
  },
};
